module.exports = __webpack_public_path__ + "static/dc-nordeste-2-eebc21468f962a8534de5cd329b79eeb.jpg";